import { forwardRef } from "react"
import { useDispatch, useSelector } from "react-redux"

import {
  isTransferringAll,
  othersSnippets,
  pinAllCurrentSnippets,
  pinnedSnippets,
  snippetsTabsValue,
  toggleIsTransferringAllSnippetsPopupDialog,
  unPinAllCurrentSnippets,
} from "rtk-slice"

import { isMobile } from "utils/mediaQuery"

import { Divider, Stack, Typography, useTheme } from "@mui/material"
import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogContentText from "@mui/material/DialogContentText"
import DialogTitle from "@mui/material/DialogTitle"
import Slide from "@mui/material/Slide"

import { MoveLeft, MoveRight } from "ui-icons"

const Transition = forwardRef((props, ref) => {
  return <Slide direction="up" ref={ref} {...props} />
})

Transition.displayName = "Transition"

const ConfirmTransferringAll = () => {
  const isTransferAllState = useSelector(isTransferringAll)
  const snippetsTabsValueState = useSelector(snippetsTabsValue)
  const pinnedSnippetsLengthState = useSelector(pinnedSnippets).length
  const othersSnippetsLengthState = useSelector(othersSnippets).length
  const dispatch = useDispatch()
  const {
    palette: {
      primary: { main },
      text: { cancel },
    },
  } = useTheme()

  const handleToggleIsTransferringAll = () => {
    dispatch(toggleIsTransferringAllSnippetsPopupDialog())
  }

  const handleTransferSnippets = () => {
    if (!snippetsTabsValueState) {
      dispatch(unPinAllCurrentSnippets())
    }
    if (snippetsTabsValueState) {
      dispatch(pinAllCurrentSnippets())
    }
    handleToggleIsTransferringAll()
  }

  return (
    <div>
      <Dialog
        open={isTransferAllState}
        fullWidth
        TransitionComponent={Transition}
        keepMounted={false}
        onClose={handleToggleIsTransferringAll}
        aria-describedby="alert-confirm-deleting-all-snippets"
        className="Test"
        sx={{
          "& .MuiBackdrop-root": {
            background: "hsl(30% 70% 10% / 0.6)",
            backdropFilter: "blur(10px)",
          },
          "& .MuiPaper-root": {
            backgroundImage: "none",
            bgcolor: "background.confirm",
            borderRadius: "1em",
            borderTop: "1px solid teal",

            "& .MuiDivider-root": {
              borderColor: "gray",
              opacity: 0.4,
            },
          },
        }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            gap: "0.5em",
            fontWeight: 900,
            bgcolor: "background.cardHeader",
          }}
          variant={isMobile() ? "h6" : "h5"}
          component="div"
        >
          {isMobile() &&
            (!snippetsTabsValueState ? (
              <MoveRight width="24" height="24" />
            ) : (
              <MoveLeft width="24" height="24" />
            ))}
          {`Move ${
            !snippetsTabsValueState ? "to Others" : "to Pinned"
          } Snippets`}
        </DialogTitle>
        <Divider />
        <DialogContent>
          <DialogContentText
            id="alert-confirm-deleting-all-snippets"
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "3em",
            }}
            component="div"
          >
            {!isMobile() &&
              (!snippetsTabsValueState ? (
                <Stack justifySelf="flex-start">
                  <MoveRight width="80" height="80" />
                </Stack>
              ) : (
                <MoveLeft width="128" height="128" />
              ))}
            <Typography variant="body1" component="span">
              {`Do you want to move ( ${
                !snippetsTabsValueState
                  ? pinnedSnippetsLengthState
                  : othersSnippetsLengthState
              } ) snippets?`}
              <br />
              <br />
              {"Press "}
              <span style={{ color: cancel }}>Cancel</span>
              {" to go back."}
              <br />
              {"Press"} <span style={{ color: main }}>MOVE</span>
              {", to continue and completely move "}
              <b>
                {snippetsTabsValueState
                  ? "ALL SHOWN OTHERS"
                  : "ALL SHOWN PINNED"}
              </b>
              {" snippets. "}
            </Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ p: "1em 2em", fontSize: "1.6rem" }}>
          <Button
            sx={{ color: main }}
            onClick={handleTransferSnippets}
            size="large"
          >
            Move
          </Button>
          <Button
            sx={{
              color: "text.cancel",
              fontSize: "1.6rem",
              textTransform: "unset",
            }}
            onClick={handleToggleIsTransferringAll}
            size="large"
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}
export default ConfirmTransferringAll
